import { IconButton } from "@mui/material";
import { ChevronDown, ChevronRight } from "lucide-react";

export const CollapseToggle = ({
  collapsed,
  label,
  onToggle,
}: {
  collapsed: boolean;
  label: string;
  onToggle: () => void;
}) => (
  <IconButton
    size="small"
    aria-label={`${collapsed ? "Expand" : "Collapse"} ${label}`}
    aria-expanded={!collapsed}
    onClick={onToggle}
    className="size-6"
  >
    {collapsed ? (
      <ChevronRight size={16} className="text-gray-500" />
    ) : (
      <ChevronDown size={16} className="text-gray-500" />
    )}
  </IconButton>
);
